import FormUrl from './FormUrl'

export default {
  // Sadly, FormUrl component is corrupted with SM logic and is not fully reusable
  // To make it generic again, we have to remove fields overwriting (dynamicPropertiesToOverwrite)
  extends: FormUrl,
  computed: {
    dynamicPropertiesToOverwrite () {
      return {}
    },
  },
}
